<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9644 19.1648V7.03779L5.26811 12.734L4.21436 11.6648L11.7144 4.16479L19.2144 11.6648L18.1606 12.734L12.4644 7.03779V19.1648H10.9644Z" fill="currentColor"/>
</svg>
